import styled from 'styled-components'

const HomeButton = styled.button`
  text-align: center;
  display: block;
  margin: auto;
  border: 0;
  width: clamp(200px, 350px, 75%);
  min-height: var(--button-height);
  cursor: pointer;
  background: var(--clr-btn);
  color: var(--clr-text-on-button) !important;
  border-radius: var(--button-border-radius);
  font-size: var(--h5);
  font-weight: 700;
  transition: all 0.5s;
`

export default HomeButton



// WEBPACK FOOTER //
// ./src/components/HomeButton/index.js